import { handleCreverseSsoTokenError } from '@/service/creverseAuth.service'
import maxios from '@/utils/axios/maxios'

// maxios 자체 에러 핸들러가 먼저 등록돼 CommonError 로 변환·reject 한 뒤 이 핸들러가 받으므로 .code 로 식별한다.
export const registerCreverseSsoInterceptor = () => {
  maxios.interceptors.response.use(undefined, (error: unknown) => {
    handleCreverseSsoTokenError(error)

    return Promise.reject(error)
  })
}
